import React from "react";
import PropTypes from "prop-types";
import { enqueueSnackbar as NotistackEnqueueSnackbar } from "notistack";
// MDB Shims 
import Container from "../../Component/MDBShim/Container";
import ToastContainer from "../../Component/MDBShim/ToastContainer";
import Row from "../../Component/MDBShim/Row";
import Fa from "../../Component/MDBShim/Fa";
import Col from "../../Component/MDBShim/Col";
import CardBody from "../../Component/MDBShim/CardBody";
import toast from "../../Component/MDBShim/toast";
import DataTable from "../../Component/MDBShim/DataTable";
import MDBNav from "../../Component/MDBShim/MDBNav";
import MDBNavItem from "../../Component/MDBShim/MDBNavItem";
import MDBNavLink from "../../Component/MDBShim/MDBNavLink";
import MDBTabContent from "../../Component/MDBShim/MDBTabContent";
import MDBTabPane from "../../Component/MDBShim/MDBTabPane";
import MDBIcon from "../../Component/MDBShim/MDBIcon";
import Button from "../../Component/MDBShim/Button";
import Spinner from "../../Component/MDBShim/Spinner";
import Modal from "../../Component/MDBShim/Modal";
import ModalFooter from "../../Component/MDBShim/ModalFooter";
import ModalBody from "../../Component/MDBShim/ModalBody";
import CardHeader from "../../Component/MDBShim/CardHeader";
import Input from "../../Component/MDBShim/Input";
import MDBBtn from "../../Component/MDBShim/MDBBtn";
import MDBCol from "../../Component/MDBShim/MDBCol";
import MDBRow from "../../Component/MDBShim/MDBRow";
import MDBCard from "../../Component/MDBShim/MDBCard";
import MDBCardHeader from "../../Component/MDBShim/MDBCardHeader";
import MDBCardBody from "../../Component/MDBShim/MDBCardBody";
import MDBModal from "../../Component/MDBShim/MDBModal";
import MDBModalBody from "../../Component/MDBShim/MDBModalBody";
import MDBContainer from "../../Component/MDBShim/MDBContainer";
import DatePicker from "../../Component/MDBShim/DatePicker";
import MDBInput from "../../Component/MDBShim/MDBInput";
import MDBModalHeader from "../../Component/MDBShim/MDBModalHeader";
import MDBModalFooter from "../../Component/MDBShim/MDBModalFooter";
import MDBSelect from "../../Component/MDBShim/MDBSelect";
import Card from "../../Component/MDBShim/Card";




import NoteService from "../Security/NoteService/noteService";
import ActivityService from "../Security/ActivityService/activityService";
import ContactService from "../Security/ContactService/contactService";
import classnames from "classnames";
import "./account.css";
import AccountService from "../Security/AccountService/accountService";
import Select from "react-select";
import ReactTooltip from "react-tooltip";
import GlobalFunctions from "../Filters/GlobalFunctions";
import InlineTable from "../../Components/Custom/InlineTable";
import noteService from "../Security/NoteService/noteService";
import LayerLegacy from "../../LayerLegacy";
import MainContext from "../../Context/MainContext/MainContext";
import MUIThemeProvider from "@mui/material/styles/ThemeProvider";
import MUICreateTheme from "@mui/material/styles/createTheme";

const fixedLightMaterialUITheme = MUICreateTheme({ palette: { mode: "light" } });

export default class accountInfo extends LayerLegacy {
    constructor(props) {
        super(props);

        let account = {},
            id = props.match.params.id;

        const notes = {
            columns: [
                {
                    label: "Type",
                    field: "type",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Created By",
                    field: "createdBy",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Created",
                    field: "createdOn",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Complete",
                    field: "completed",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Text",
                    field: "text",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Edit",
                    field: "button",
                    sort: "asc",
                    width: 100,
                },
            ],
            rows: [],
        };

        const activities = {
            columns: [
                {
                    label: "Type",
                    field: "type",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Date",
                    field: "expenseDate",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Marketing",
                    field: "quality",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Spent",
                    field: "expenses",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "At",
                    field: "at",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "For",
                    field: "for",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Edit",
                    field: "edit",
                    sort: "asc",
                    width: 100,
                },
            ],
            rows: [],
        };

        const orders = {
            columns: [
                {
                    label: "Order Id",
                    field: "id",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Status",
                    field: "status",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Reason",
                    field: "reason",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Name",
                    field: "patientName",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Date",
                    field: "when",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Payor Source",
                    field: "insuranceType",
                    sort: "asc",
                    width: 100,
                },
            ],
            rows: [],
        };

        const contacts = {
            columns: [
                {
                    label: "Name",
                    field: "name",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Type",
                    field: "type",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Title",
                    field: "role",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Phone",
                    field: "phone",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Email",
                    field: "mail",
                    sort: "asc",
                    width: 100,
                },
                {
                    label: "Edit",
                    field: "edit",
                    sort: "asc",
                    width: 100,
                },
            ],
            rows: [],
        };

        const columnMap = [
            { columnName: "ID", fieldName: "id", canEdit: false, type: "text", required: false, hidden: true },
            { columnName: "Product Type", fieldName: "productTypeId", canEdit: true, type: "dropdown", required: true, options: [] },
            { columnName: "Product Sub Type", fieldName: "productSubTypeId", canEdit: true, type: "dropdown", required: true, options: [], filter: "productTypeId", unique: true },
            { columnName: "Rate", fieldName: "rate", canEdit: true, type: "float", required: true, },
            { columnName: "Deleted", fieldName: "deleted", canEdit: true, type: "bool", required: false, hidden: true, defaultValue: false },
        ];

        this.state = {
            account: account,
            accountId: id,
            editedAccount: JSON.parse(JSON.stringify(account)),
            notes: notes,
            notesLoaded: false,
            activities: activities,
            activitiesLoaded: false,
            orders: orders,
            ordersLoaded: false,
            contacts: contacts,
            contactsLoaded: false,
            taskCompleted: false,
            noteModalOpen: false,
            contactModalOpen: false,
            noteText: "",
            activeItem: "5",
            typeRadio: "Note",
            newContact: {
                account: {},
                contactType: {},
                email: "",
                firstname: "",
                lastname: "",
                phone: "",
                role: "",
            },
            newActivity: {
                account: account,
                accountId: account.id,
                expenseDate: new Date(),
                quality: false,
                contacts: [],
                type: "Appointment",
            },
            newCall: {
                account: account,
                quality: false,
                contacts: [],
                type: "Call",
                endedAt: new Date(),
                callType: null,
                callReason: null,
            },
            callTypes: [
                { label: "Face-To-Face", value: "FTF" },
                { label: "LCMP Evaluation", value: "LCMP Evaluation" },
                { label: "Drop Ins", value: "Drop Ins" },
            ],
            callReasons: [
                { label: "Following up with new information from a previous meeting", value: "Following up with new information from a previous meeting" },
                { label: "Following up regarding new information about changes in LCDs", value: "Following up regarding new information about changes in LCDs" },
                { label: "Paperwork Education/Streamlining Processes", value: "Paperwork Education/Streamlining Processes" },
                { label: "Equipment Changes", value: "Equipment Changes" },
                { label: "Policy Changes", value: "Policy Changes" },
                { label: "Other industry and/or inter-company changes that our accounts need to be aware of", value: "Other industry and/or inter-company changes that our accounts need to be aware of" },
                { label: "Other", value: "Other" },
            ],
            modalNote: {},
            editNoteOpen: false,
            callModalOpen: false,
            appointmentModalOpen: false,
            dueDate: null,
            contactList: [],
            callNoteText: "",
            allNotes:[],
            contactTypes: [],
            allContactTypes: [],
            marketingCampaigns: [],
            accountTypes: [],
            cardTypes: [],
            expenseTypes: [],
            allCardTypes: [],
            allExpenseTypes: [],

            pricesheets: [],
            pricesheetsLoaded: false,
            filteredProductSubTypes: [],
            pricesheetColumnMap: columnMap,
            productTypes: [],
            productSubTypes: [],
            salesLocations: [],
        };
    }

    static contextType = MainContext; // For legacy class components

    componentDidMount(){
        let id = this.state.accountId;
        this.getMasterAccounts();
        this.getCardList();
        this.getExpenseTypeList();

        this.getAccountTypeList();
        this.getContactTypesList();

        this.fetchAccount(id);
        this.retrieveActivities(id);
        this.getPricesheets(id);
    }

    componentDidUpdate() {
        const { cardTypes, expenseTypes, contactTypes } = this.context;
        if (cardTypes.length !== this.state.allCardTypes.length) {
            this.getCardList();
        }
        if (expenseTypes.length !== this.state.allExpenseTypes.length) {
            this.getExpenseTypeList();
        }
        if (contactTypes.length !== this.state.allContactTypes.length) {
            this.getContactTypesList();
        }
    }

    toggle = (tab) => {
        if (this.state.activeItem !== tab) {
            this.setState({
                activeItem: tab,
            });
        }
    };

    //DATA
  fetchAccount(id) {
    let newActivity = this.state.newActivity,
        newCall = this.state.newCall;

    return AccountService.getAccount(id)
        .then((data) => {
            let accountReference = { id: data.id, name: data.name };

            newActivity.account = accountReference;
            newCall.account = accountReference;

            let contactRows = [],
                contactsTable = this.state.contacts,
                contactSelectOptions = [];

            data.contact.forEach(contact => {
                contactRows.push({
                    name: contact.lastname + "," + contact.firstname,
                    type: contact.contactType ? contact.contactType.name : "No Type",
                    role: contact.role || "No Role",
                    phone: contact.phone || "No Phone",
                    mail: contact.email || "No Email",
                    edit: this.routeContact(contact),
                });

                contactSelectOptions.push({
                    label: contact.firstname + " " + contact.lastname,
                    value: {
                        id: contact.id,
                        firstname: contact.firstname,
                        lastname: contact.lastname,
                    },
                });
            });

            contactsTable.rows = contactRows;

            this.setState(
                {
                    account: data,
                    newActivity: newActivity,
                    newCall: newCall,
                    editedAccount: JSON.parse(JSON.stringify(data)),
                    notesLoaded: true,
                    contacts: contactsTable,
                    contactList: contactSelectOptions,
                    contactsLoaded: true,
                },
                () => {
                    this.getAccountNotes(id);
                    this.getMarketingCampaigns();
                    this.getSalesLocationOptions();
                }
            );
        });
}


    sortNotesByDate(notes){
        let sorted = notes.sort((a,b) => {
            let da = new Date(a.createdAt).getTime(),
                db = new Date(b.createdAt).getTime();

            return da > db ? -1: 1;
        });
        return sorted;
    }

    getSalesLocationOptions() {
        const {
            currentUser,
            userprofileLocationsIndexed,
            locationsIndexed,
            allLocations
        } = this.context;

        const account = this.state.editedAccount;

        const userProfileLocationsForCurrentUser = Object.values(userprofileLocationsIndexed)
            .filter((userprofileLocation) => {
                return userprofileLocation.userprofileId === currentUser.id;
            });

        let userLocations = userProfileLocationsForCurrentUser
            .map((userprofileLocation) => {
                return locationsIndexed[userprofileLocation.locationsId];
            })
            .filter((location) => {
                return location != null;
            });

        if (account.locationId) {
            const hasAccountLocation = userLocations.find(
                (location) => location.id === account.locationId
            );

            if (!hasAccountLocation) {
                const accountLocation = allLocations.find(
                    (location) => location.id === account.locationId
                );

                if (accountLocation) {
                    userLocations.push(accountLocation);
                }
            }
        }

        let selectOptions = [];

        userLocations.forEach((location) => {
                selectOptions.push({
                    label: location.name,
                    value: location.id,
                });
        });

        this.setState({
            salesLocations: selectOptions,
        });
    }

    getAccountNotes(id) {
        noteService.getNotesByAccount(id)
            .then(res => {
                this.setState({
                    allNotes: this.sortNotesByDate(res),
                });
            })
            .catch(err => {
                console.log(err);
            });
    }

    getPricesheets(id) {
        const { companyName } = this.context;

        if (companyName !== "rehabmedical") {
            AccountService.GetAccountPricesheets(id)
                .then(res => {
                    this.setState({
                        pricesheets: res || [],
                        pricesheetsLoaded: true,
                    }, () => this.updateColumnMap());
                })
                .catch(ex => {
                    console.log(ex);
                    this.setState({
                        pricesheetsLoaded: true,
                    });
                });
        }
    }

    updateColumnMap() {
        const { productTypes, productSubTypes } = this.context;
        if (productTypes && productTypes.length > 0) {
            var ptOpts = [],
                map = this.state.pricesheetColumnMap;
            productTypes.map(p => {
                return ptOpts.push({
                    label: p.name,
                    value: p.id,
                    realValue: p,
                });
            });
            map[1].options = ptOpts;
            this.setState({
                pricesheetColumnMap: map,
            });
        }

        if (productSubTypes && productSubTypes.length > 0) {
            var pstOpts = [],
                smap = this.state.pricesheetColumnMap;
            productSubTypes.map(p => {
                return pstOpts.push({
                    label: p.name,
                    value: p.id,
                    realValue: p,
                });
            });
            smap[2].options = pstOpts;
            this.setState({
                pricesheetColumnMap: smap,
            });
        }
    }

    getMasterAccounts() {
        AccountService.getMasterAccounts()
            .then(result => {
                var masterAccountOptions = [];
                if (result && result.length > 0) {
                    result.map(account => {
                        return masterAccountOptions.push({
                            // checked:true,
                            text: account.name,
                            value: account.id,
                        });
                    });
                }
                else {
                    masterAccountOptions.push({
                        disabled: true,
                        text: '---No Master Accounts Found---',
                        value: null,
                    });
                }
                this.setState({
                    masterAccounts: masterAccountOptions,
                });
            });
    }


    getCardList() {
        const { cardTypes } = this.context;

        let a = [];
        a.push({
            label: "Select Card Type...",
            value: "",
        });

        cardTypes.map((card) => {
            return a.push({
                label: card.name,
                value: card,
            });
        });

        this.setState({
            cardTypes: a,
            allCardTypes: cardTypes,
        });
    }

    getExpenseTypeList() {
        const { expenseTypes } = this.context;
        let activity = this.state.newActivity,
            a = [];

        a.push({
            label: "Select Expense Type...",
            value: "",
        });

        expenseTypes.map((exp) => {
            if (activity.cardType != null) {
                if (exp.cardTypes) {
                    let i = exp.cardTypes.findIndex((x) => x.id === activity.cardType.id);
                    if (i > -1) {
                        return a.push({
                            label: exp.name,
                            value: exp,
                        });
                    }
                }
            } else {
                return a.push({
                    label: exp.name,
                    value: exp,
                });
            }

            return null;
        });
        this.setState({
            expenseTypes: a,
            allExpenseTypes: expenseTypes,
        });
    }

    getContactTypesList() {
        const { contactTypes } = this.context;
        let a = [];
        a.push({
            label: "Select Category...",
            value: "",
        });
        contactTypes.map((type) => {
            return a.push({
                label: type.name,
                value: type,
            });
        });
        this.setState({
            contactTypes: a,
            allContactTypes: contactTypes,
        });
    }

    handleCardTypeSelected = (e) => {
        let activity = this.state.newActivity;

        activity.cardType = { name: e.value.name, id: e.value.id };
        activity.cardTypeId = e.value.id;

        this.setState({
            newActivity: activity,
        });
    };

    handleExpenseTypeSelected = (e) => {
        let activity = this.state.newActivity;

        activity.expenseType = { name: e.value.name, id: e.value.id };
        activity.expenseTypeId = e.value.id;

        this.setState({
            newActivity: activity,
            selectedExpense: e.value,
        });
    };

    validateActivity(activity) {
        let shouldContinue = true;

        if (!activity.account) {
            toast.warn("Please pick an account");
            NotistackEnqueueSnackbar('Please pick an account', { variant: "error" });
            shouldContinue = false;
        }

        if (!activity.type) {
            toast.warn("Please select an activity type");
            NotistackEnqueueSnackbar('Please select an activity type', { variant: "error" });
            shouldContinue = false;
        }

        if (activity.type === "Appointment") {
            if (!activity.expenseDesc) {
                toast.warn("Please provide a description");
                NotistackEnqueueSnackbar('Please provide a description', { variant: "error" });
                shouldContinue = false;
            }

            if (!activity.expenseDate) {
                toast.warn("Please set the date");
                NotistackEnqueueSnackbar('Please set the date', { variant: "error" });
                shouldContinue = false;
            }

            if (activity.expenses < 0) {
                toast.warn("Amount spent should be no less than 0");
                NotistackEnqueueSnackbar('Amount spent should be no less than 0', { variant: "error" });
                shouldContinue = false;
            }

            if (!activity.vendor) {
                toast.warn("Please identify the vendor");
                NotistackEnqueueSnackbar('Please identify the vendor', { variant: "error" });
                shouldContinue = false;
            }

            if (!activity.peopleAttending) {
                toast.warn("Please identify how many people were attending");
                NotistackEnqueueSnackbar('Please identify how many people were attending', { variant: "error" });
                shouldContinue = false;
            }

            if (!activity.educationalTopics) {
                toast.warn("Please identify the topics discussed");
                NotistackEnqueueSnackbar('Please identify the topics discussed', { variant: "error" });
                shouldContinue = false;
            }

            if (activity.expenses > 0) {
                if (!activity.expenseType) {
                    toast.warn("Please select an expense type");
                    NotistackEnqueueSnackbar('Please select an expense type', { variant: "error" });
                    shouldContinue = false;
                }

                if (!activity.cardType) {
                    toast.warn("Please select a card type");
                    NotistackEnqueueSnackbar('Please select a card type', { variant: "error" });
                    shouldContinue = false;
                }
            }
        }
        else if(activity.type === "Call"){
            if(activity.quality === true && (!activity.contacts || activity.contacts.length === 0)){
                toast.warn("Please select a contact");
                NotistackEnqueueSnackbar('Please select a contact', { variant: "error" });
                shouldContinue = false;
            }

            if(activity.quality === false && !activity.callType){
                toast.warn("Please select a call type");
                NotistackEnqueueSnackbar('Please select a call type', { variant: "error" });
                shouldContinue = false;
            }

            if(activity.quality === true && activity.callReason === null){
                toast.warn("Please select a call reason");
                NotistackEnqueueSnackbar('Please select a call reason', { variant: "error" });
                shouldContinue = false;
            }

            let nText = document.getElementById("newNoteText");
            if(activity.quality === true && activity.callReason === "Other" && nText != null && nText.value === ""){
                toast.warn("Please enter the reason note");
                NotistackEnqueueSnackbar('Please enter the reason note', { variant: "error" });
                shouldContinue = false;
            }
        }

        return shouldContinue;
    }

    createActivity(type) {
        this.setState({ saveLoading: true });

        const originalActivity = JSON.parse(JSON.stringify(
            type === "Appointment" ? this.state.newActivity : this.state.newCall
        ));

        let na = {
            type: type,
            accountId: parseInt(this.state.accountId),
            ownerId: this.state.account.ownerId,
            endedAt: new Date().toISOString(),
            startedAt: new Date().toISOString(),
            quality: type === "Call" ? (this.state.newCall.quality || false) : false,
            priority: 0,
            isExpense: type === "Appointment",
        };

        if (type === "Appointment") {
            let shouldCreate = this.validateActivity(originalActivity);

            if (!shouldCreate) {
                this.setState({ saveLoading: false });
                return;
            }

            if (originalActivity.expenseReceipt) {
                const commaIndex = originalActivity.expenseReceipt.indexOf(",");
                originalActivity.expenseReceipt = originalActivity.expenseReceipt.slice(commaIndex + 1);
            }

            if (originalActivity.expenses) {
                originalActivity.expenses = parseFloat(originalActivity.expenses);
            }

            delete originalActivity.contacts;
            delete originalActivity.endedAt;
            delete originalActivity.quality;
            delete originalActivity.type;
            delete originalActivity.account;

            na.appointmentActivity = originalActivity;
        } else {
            let shouldCreate = this.validateActivity(originalActivity);

            if (!shouldCreate) {
                this.setState({ saveLoading: false });
                return;
            }

            na.activityContact = originalActivity.contacts?.map(c => ({
                accountId: this.state.accountId,
                contactId: c.id,
                contact: c
            })) || [];

            delete originalActivity.contacts;
            delete originalActivity.endedAt;
            delete originalActivity.quality;
            delete originalActivity.type;
            delete originalActivity.account;

            na.callActivity = originalActivity;
        }

        return ActivityService.createActivity(na)
            .then((res) => {
                const clonedActivity = JSON.parse(JSON.stringify(this.state.newActivity)); // Safe copy

                const newActivity = {
                    account: clonedActivity.account,
                    accountId: clonedActivity.account?.id ?? null,
                    expenseDate: new Date(),
                    quality: false,
                    contacts: [],
                    type: "Appointment",
                };

                const newCall = {
                    quality: false,
                    contacts: [],
                    type: "Call",
                    endedAt: new Date(),
                    callReason: null,
                    callType: null,
                };

                this.setState({
                    newActivity: newActivity,
                    activitiesLoaded: false,
                    appointmentModalOpen: false,
                    newCall: newCall,
                    callModalOpen: false,
                });

                if (na.type === "Call" && this.state.callNoteText) {
                    this.createActivityNote(res);
                }
                NotistackEnqueueSnackbar('Activity created successfully', { variant: "success" });
                this.retrieveActivities(this.state.accountId);
            })
            .catch((err) => {
                toast.error("Oh! There was an error creating the Activity.");
                NotistackEnqueueSnackbar('Error creating activity', { variant: "error" });
               this.setState({ saveLoading: false });
           });
    }


    createActivityNote(activity) {
        const { currentUser } = this.context;
        let noteRadio = this.state.noteRadio,
            accountDTO = activity.account,
            txt = this.state.callNoteText,
            cb = { id: currentUser.id, name: currentUser.username };

        let note = {
            text: txt,
            account: accountDTO,
            accountId: accountDTO.id,
            completed: true,
            task: false,
            createdAt: GlobalFunctions.getUTCMoment(),
            activityId: activity.id,
            createdBy: cb,
            createdById: cb.id,
        };

        if (noteRadio === "Task") {
            note.completed = false;
            note.task = true;
            note.assignedTo = this.state.account.owner;
            note.assignedToId = this.state.account.owner.id;
        }

        return NoteService.createActivityNote(activity.id, note)
            .then((res) => {
            })
            .catch((err) => {
                console.log("Oh! There was an error creating the Task.");
            });
    }

    encodeImageFileAsURL(element) {
        let file = element[0],
            reader = new FileReader();
        reader.onloadend = () => {
            this.state.newActivity.expenseReceipt = reader.result;
            this.setState({ newActivity: this.state.newActivity });
        };
        reader.readAsDataURL(file);
    }

    getMarketingCampaigns() {
        let marketingCampaignsOptions = [];
        Object.values(this.context.marketingCampaignsIndexed).map((type) => {
            if (type.isActive || (!type.isActive && this.state.editedAccount.marketingCampaignId === type.id)) {
                return marketingCampaignsOptions.push({
                    label: type.name,
                    value: type.id,
                    marketingCampaignValue: type,
                });
            }
            return null;
        });

        this.setState({ marketingCampaigns: marketingCampaignsOptions });
        return marketingCampaignsOptions;
    }

    updateNoteModal(note) {
        let noteText = document.getElementById("noteTextArea").value;

        let upDate = "Updated: " + GlobalFunctions.formatDate(new Date());
        note.text = noteText + " -- " + upDate;

        this.updateNote(note, null, true);
    }

    updateNote(note, complete) {
        const { currentUser } = this.context;

        let notes = this.state.allNotes,
            noteToReplace = notes.findIndex((note) => {
                return note.id === note.id;
            });

        if (noteToReplace > -1) {
            notes.splice(noteToReplace, 1, note);
        }

        if (complete != null) {
            note.completed = complete;

            note.text +=
				" --> Completed by " +
				currentUser.username +
				" on " +
				GlobalFunctions.formatDate(new Date());
        }

        return NoteService.updateActivityNote(note)
            .then((res) => {
                this.setState({
                    allNotes: notes,
                });
            })
            .catch((err) => {
                console.log(err);
            });
    }

    sortNotes(allNotes, task) {
        let t = [],
            n = [];

        if(allNotes){
            allNotes.forEach((note) => {
                if (note.completed === false) {
                    t.push(note);
                } else {
                    n.push(note);
                }
            });
        }

        if (task) {
            return t;
        }
        return n;
    }

    toggleEditModalPopup(note) {
        const { currentUser } = this.context;

        let currentState = this.state.editNoteOpen,
            ncopy = {};

        if (note) {
            ncopy = JSON.parse(JSON.stringify(note));

            if (currentUser) {
                if (
                    currentUser.role === "ADMIN"
                ) {
                    //we are fine, continue
                } else if (currentUser.username !== note.createdBy.username) {
                    //they do not own this note.  They shouldn't be able to edit it.
                    return;
                }
            } else {
                return;
            }
        }

        this.setState({
            editNoteOpen: !currentState,
            modalNote: ncopy,
        });
    }

    toggleNoteModalPopup() {
        let currentState = this.state.noteModalOpen;
        this.setState({ noteModalOpen: !currentState });
    }

    toggleContactModalPopup() {
        let currentState = this.state.contactModalOpen;
        this.setState({ contactModalOpen: !currentState });
    }

    contactChange = (property, event) => {
        let contact = this.state.newContact;
        contact[property] = event.target.value;
        this.setState({ newContact: contact });
    };

    handleContactTypeSelected = (e) => {
        let con = this.state.newContact;

        con.contactType = { name: e.value.name, id: e.value.id };
        con.contactTypeId = e.value.id;

        this.setState({
            newContact: con,
        });
    };

    addNewNote() {
        //get the current user context that can be passed into the note DTO...BC
        //another comment...BC
        const { currentUser } = this.context;
        let cb = { id: currentUser.id, name: currentUser.username },
            currentNotes = this.state.allNotes,
            acc = this.state.account;

        let nText = document.getElementById("newActivityNoteText").value;

        console.log(this.state.dueDate);

        let note = {
    
            type: "AccountNote",
            text: nText,
            createdAt: GlobalFunctions.getUTCMoment(),
            accountId: acc.id,
            // account: { id: acc.id, name: acc.name },
            task: !this.state.taskCompleted,
            createdBy: cb,
            createdById: cb.id,
            completed: this.state.taskCompleted,
            dueDate: this.state.dueDate ? this.state.dueDate instanceof Date ? this.state.dueDate.toISOString() : new Date(this.state.dueDate).toISOString() : new Date().toISOString(),
        };

        if (!this.state.completed) {
            note.assignedTo = this.state.account.owner;
            note.assignedToId = this.state.account.owner.id;
        }

        return NoteService.createAccountNote(note)
            .then((res) => {
                this.toggleNoteModalPopup();
                currentNotes.unshift(note);
                NotistackEnqueueSnackbar('Note created successfully', { variant: "success" });
                this.setState({ allNotes: currentNotes });
            })
            .catch((err) => {
                NotistackEnqueueSnackbar('Error creating note', { variant: "error" });
                //Maybe send an error to the user?...BC
            });
    }

    addNewContact() {
        let obj = this.state.newContact,
            acc = this.state.editedAccount;

        obj.account = { name: acc.name, id: acc.id };
        obj.accountId = acc.id;

        this.setState({ contactsLoaded: false });

        //change to add contact
        return ContactService.createContact(obj)
            .then((res) => {
                toast.success("Contact Created");
                NotistackEnqueueSnackbar('Contact Created', { variant: "success" });

                let dt = this.state.contacts;

                dt.rows.push({
                    name: res.lastname + "," + res.firstname,
                    type: res.contactType ? res.contactType.name : "No Type",
                    role: res.role || "No Role",
                    phone: res.phone || "No Phone",
                    mail: res.email || "No Email",
                    edit: this.routeContact(res),
                });

                let n = {
                    account: {},
                    contactType: {},
                    email: "",
                    firstname: "",
                    lastname: "",
                    phone: "",
                    role: "",
                };

                this.setState({
                    contactsLoaded: true,
                    contacts: dt,
                    newContact: n,
                });

                this.createNoteTask(acc, res.id);
            })
            .catch((err) => {
                console.log(err);
                toast.error("There was an error.  Make sure all fields are filled out");
                NotistackEnqueueSnackbar('There was an error.  Make sure all fields are filled out', { variant: "error" });
                this.setState({ contactsLoaded: true });
            });
    }

    createNoteTask(account, contactID) {
        const { currentUser } = this.context;

        let typeRadio = this.state.typeRadio,
            accountDTO = { id: account.id, name: account.name },
            cb = { id: currentUser.id, name: currentUser.username };

        let nText = document.getElementById("newNoteText").value;

        //we don't have any text, no note to create
        if (nText === "") {
            this.toggleContactModalPopup();
        } else {
            let note = {
                text: nText,
                account: accountDTO,
                accountId: accountDTO.id,
                completed: true,
                task: false,
                createdAt: GlobalFunctions.getUTCMoment(),
                createdBy: cb,
                createdById: cb.id,
            };

            if (typeRadio === "Task") {
                note.completed = false;
                note.task = true;
                note.assignedTo = account.owner;
                note.assignedToId = account.owner.id;
            }

            return NoteService.createContactNote(contactID, note)
                .then((res) => {
                    toast.success("Contact task successfully created.");
                    NotistackEnqueueSnackbar('Contact task successfully created.', { variant: "success" });
                    this.toggleContactModalPopup();
                })
                .catch((err) => {
                    console.log(err);
                    toast.warn("Oh! There was an error creating the contact task.");
                    NotistackEnqueueSnackbar('Oh! There was an error creating the contact task.', { variant: "error" });
                    this.toggleContactModalPopup();
                });
        }
    }

    updateAccount() {
        let acc = this.state.editedAccount;
        if (!acc.locationId) {
            toast.warn("Please select a Sales Location before saving.");
            NotistackEnqueueSnackbar('Please select a Sales Location before saving.', { variant: "error" });
            return;
        }
        return AccountService.updateAccount(acc)
            .then((data) => {
                this.setState({
                    account: data,
                    editedAccount: JSON.parse(JSON.stringify(data)),
                });
                toast.success("Saved Successfully!");
                NotistackEnqueueSnackbar('Saved Successfully!', { variant: "success" });
            })
            .catch((err) => {
                toast.warn("An error occurred while saving.");
                NotistackEnqueueSnackbar('An error occurred while saving.', { variant: "error" });
            });
    }

    handleChange = (property, event) => {
        //update the property that the user has edited in the order...BC
        const nAccount = this.state.editedAccount;
        nAccount[property] = event.target.value;
        this.setState({ editedAccount: nAccount });
    };

    handleSelectChange = (property, e) => {
        let editedAccount = this.state.editedAccount;

        if (property === "marketingCampaign") {
            editedAccount.marketingCampaign = e.marketingCampaignValue;
            editedAccount.marketingCampaignId = e.marketingCampaignValue.id;
        } else if (property === "accountTypeId") {
            editedAccount.accountTypeId = e.value.id;
        }
        this.setState({ editedAccount: editedAccount });
    };

    retrieveActivities(id) {
        return ActivityService.getActivitiesByAccount(id)
            .then((data) => {
                let activityRows = [],
                    orderRows = [],
                    activitiesTable = this.state.activities,
                    ordersTable = this.state.orders,
                    activities = data;
                let stats = ["New", "In Process", "Ready to Deliver", "Setup", "Cancelled"];
                activities.forEach((activity, index) => {
                    if (activity.type === "Call" || activity.type === "Appointment") {
                        activityRows.push({
                            type: activity.type,
                            expenseDate: activity.appointmentActivity
                                ? activity.appointmentActivity.expenseDate ?
                                    GlobalFunctions.customFormatDateMoment(activity.appointmentActivity.expenseDate,"YYYY-MM-DD") :
                                    GlobalFunctions.customFormatDateMoment(activity.endedAt,"YYYY-MM-DD")
                                : GlobalFunctions.customFormatDateMoment(activity.endedAt,"YYYY-MM-DD"),
                            quality: activity.quality ? "Yes" : "No",
                            expenses: activity.appointmentActivity
                                ? this.formatCurrency(activity.appointmentActivity.expenses)
                                : "No Expenses",
                            at: activity.appointmentActivity ? activity.appointmentActivity.vendor : "No Vendor",
                            for: activity.appointmentActivity ? activity.appointmentActivity.expenseDesc : "No Description",
                            edit: this.renderRouteButton(activity, index),
                        });
                    }
                    else if (activity.type === "Order" && activity.orderActivity) {
                        orderRows.push({
                            id: this.routeOrder(activity.orderActivity, index),
                            status: activity.orderActivity ? stats[activity.orderActivity.status] : "No Status",
                            reason: activity.orderActivity && activity.orderActivity.orderStatusReason ? activity.orderActivity.orderStatusReason.description : "No Reason",
                            patientName: activity.orderActivity ? activity.orderActivity.patientName : "",
                            when: GlobalFunctions.formatDateTime(activity.startedAt),
                            insuranceType: activity.orderActivity && activity.orderActivity.insuranceType ? activity.orderActivity.insuranceType.name : "No Insurance",
                        });
                    }
                });

                activityRows.sort((a, b) => {
                    if (a.expenseDate > b.expenseDate) {
                        return -1;
                    } else {
                        return 1;
                    }
                });
                activitiesTable.rows = activityRows;
                ordersTable.rows = orderRows;
                this.setState({
                    activities: activitiesTable,
                    orders: ordersTable,
                    activitiesLoaded: true,
                    ordersLoaded: true,
                });
            })
            .catch((err) => {
                console.log(err);
            });
    }

    renderRouteButton(activity, index) {
        return (
            <MDBIcon
                icon="edit"
                aria-hidden="true"
                color="warning"
                onClick={() => {
                    this.props.history.push({
                        pathname: "/activity/" + activity.id,
                        state: {
                            //activity: activity,
                            prevPage: this.state.account.id + "",
                        },
                    });
                }}
            />
        );
    }

    renderActivityTable() {
        if (this.state.activitiesLoaded === true) {
            return (
                <DataTable striped info={false} small order={['date' ]} data={this.state.activities}>
                    {" "}
                </DataTable>
            );
        } else {
            return <Spinner size="small" />;
        }
    }


    routeOrder(order) {
        if (order && order.id) {
            return (
                <a
                    style={{ color: "#00afd7" }}
                    href={"/chart/" + order.patientId + "/order/" + order.id}
                    onClick={() => {
                        this.setState({ order: order });
                    }}
                >
                    {order.id}
                </a>
            );
        }
        else {
            return null;
        }
    }

    renderOrderTable() {
        if (this.state.ordersLoaded === true) {
            return (
                <DataTable striped info={false} small data={this.state.orders}>
                    {" "}
                </DataTable>
            );
        } else {
            return <div></div>;
        }
    }

    renderReceipt() {
        if (!this.state.newActivity.expenseReceipt) {
            return <div></div>;
        } else {
            return (
                <img
                    style={{ width: "200px", height: "300px" }}
                    src={this.state.newActivity.expenseReceipt}
                    alt="Invalid format"
                />
            );
        }
    }

    renderInformationSection() {
        const { companyName } = this.context;
        let account = this.state.editedAccount,
            masAcc = this.state.masterAccounts,
            selAccIndex = account.masterAccountId && masAcc ? masAcc.findIndex(x => x.value === account.masterAccountId) : -1,
            selAcc = null;

        if(selAccIndex !== -1 ){
            selAcc = masAcc[selAccIndex];
            selAcc.checked=true;
        }
        return (
            <div>
                <Row style={{ paddingLeft: "16px", paddingRight: "16px", }} gap={3}>
                    <Col className={"outlineBoxWithLabel"} md="5.5">
                        <label className="patientInfoLabel">Account Contact Info</label>
                        <Input
                            value={account.name}
                            outline
                            onChange={this.handleChange.bind(this, "name")}
                            label="Account Name"
                            icon="user-circle"
                            style={{ width: "100%" }}
                        />
                        <Input
                            value={account.phoneNumber}
                            outline
                            onChange={this.handleChange.bind(this, "phoneNumber")}
                            label="Phone"
                            icon="phone"
                            style={{ width: "100%" }}
                        />
                        <Input
                            value={account.faxNumber}
                            outline
                            onChange={this.handleChange.bind(this, "faxNumber")}
                            label="Fax"
                            icon="fax"
                            style={{ width: "100%" }}
                        />
                        <Input
                            value={account.email}
                            outline
                            onChange={this.handleChange.bind(this, "email")}
                            label="E-mail"
                            icon="envelope"
                            style={{ width: "100%", marginBottom: "16px" }}
                        />
                    </Col>
                    <Col className={"outlineBoxWithLabel"} md="5.5">
                        <label className="patientInfoLabel">Account Location Info</label>
                        <Input
                            value={account.addrLine1}
                            outline
                            onChange={this.handleChange.bind(this, "addrLine1")}
                            label="Address"
                            icon="address-book"
                            style={{ width: "100%" }}
                        />
                        <Input
                            value={account.city}
                            outline
                            onChange={this.handleChange.bind(this, "city")}
                            label="City"
                            icon="city"
                            style={{ width: "100%" }}
                        />
                        <Input
                            value={account.state}
                            outline
                            onChange={this.handleChange.bind(this, "state")}
                            label="State"
                            icon="map-marked-alt"
                            style={{ width: "100%" }}
                        />
                        <Input
                            value={account.zip}
                            outline
                            onChange={this.handleChange.bind(this, "zip")}
                            label="ZipCode"
                            icon="map-pin"
                            style={{ width: "100%", marginBottom: "16px" }}
                        />
                    </Col>
                </Row>

                <Row style={{ paddingLeft: "16px", paddingRight: "16px", }} gap={3}>
                    <Col className={"outlineBoxWithLabel"} md="5.5">
                        <label className="patientInfoLabel">Account Type</label>
                        <div style={{marginBottom: "1.4rem"}}>
                            <Select
                                placeholder={
                                    account.marketingCampaign
                                        ? account.marketingCampaign.name
                                        : "Select Marketing Campaign..."
                                }
                                options={this.state.marketingCampaigns}
                                onChange={this.handleSelectChange.bind(this, "marketingCampaign")}
                                
                            />
                        </div>

                        <div style={{ marginBottom: "16px" }}>
                            <Select
                                placeholder={
                                    account.accountType
                                        ? account.accountType.name
                                        : "Select Account Type..."
                                }
                                options={this.state.accountTypes}
                                onChange={this.handleSelectChange.bind(this, "accountTypeId")}
                                
                            />
                        </div>
                    </Col>

                    <Col className={"outlineBoxWithLabel"} md="5.5">
                        <label className="patientInfoLabel">Sales Settings</label>

                        <div className="target-account-checkbox">
                            <Input
                                onChange={(event) => {
                                    let updatedAccount = this.state.editedAccount;
                                    updatedAccount.isTarget = event.target.checked;
                                    this.setState({ editedAccount: updatedAccount });
                                }}
                                filled
                                checked={this.state.editedAccount.isTarget === true}
                                label="Target Account"
                                type="checkbox"
                                id="checkbox_target_account"
                            />
                        </div>

                        <div style={{ marginTop: "1.4rem", marginBottom: "16px" }}>
                            <Select
                                placeholder="Select Sales Location..."
                                value={
                                    this.state.salesLocations.find(
                                        location => location.value === account.locationId
                                    ) || null
                                }
                                options={this.state.salesLocations}
                                onChange={(selectedOption) => {
                                    let updatedAccount = this.state.editedAccount;
                                    updatedAccount.locationId = selectedOption.value;
                                    this.setState({ editedAccount: updatedAccount });
                                }}
                            />
                        </div>
                    </Col>
                </Row>

                {(companyName !== "rehabmedical") ? (
                    <Row style={{ paddingLeft: "16px", paddingRight: "16px", }}>
                        <Col md="6" className={"outlineBoxWithLabel"}>
                            <label className="patientInfoLabel">Account Type</label>

                            <Row style={{ marginBottom: "0.4rem" }}>
                                <Col style={{ marginRight: "16px" }}>
                                    <MDBBtn
                                        disabled={account.isMaster}
                                        style={{ display: "block", margin: "auto" }}
                                        onClick={() => {
                                            account.isMaster = true;
                                            account.masterAccountId = null;
                                            this.setState({ editedAccount: account });
                                        }}
                                        size="md"
                                        color="primary"
                                    >
                                        Set As A Master Account
                                    </MDBBtn>
                                    {account.isMaster && (
                                        <div className={"accountIconDiv"}>
                                            <MDBIcon icon={"check"} color={"primary"} />
                                            This Is A Master Account
                                        </div>
                                    )}
                                </Col>

                                <Col>
                                    <MDBBtn
                                        disabled={!account.isMaster}
                                        style={{ display: "block", margin: "auto" }}
                                        onClick={() => {
                                            account.isMaster = false;
                                            this.setState({ editedAccount: account });
                                        }}
                                        size="md"
                                        color="danger"
                                    >
                                        Set As A Normal Account
                                    </MDBBtn>

                                    {!account.isMaster && (
                                        <div className={"accountIconDiv"}>
                                            <MDBIcon icon={"check"} color={"primary"} />
                                            This Is A Normal Account
                                        </div>
                                    )}
                                </Col>
                            </Row>

                            {!account.isMaster && (
                                <MDBSelect
                                    label={selAcc ? "Master Account" : "Select Master Account"}
                                    className={"smallMargin searchField"}
                                    outline={true}
                                    search={true}
                                    selected={selAcc ? selAcc.text : "Select Master Account"}
                                    options={this.state.masterAccounts}
                                    getValue={(e) => {
                                        if (e && e.length > 0) {
                                            account.masterAccountId = e[0];
                                        } else {
                                            account.masterAccountId = null;
                                        }
                                        this.setState({ editedAccount: account });
                                    }}
                                />
                            )}

                            <Input
                                type="number"
                                value={account.rentalFee}
                                placeholder="Rental Fee"
                                label="Rental Fee"
                                outline
                                onChange={(event) => {
                                    account.rentalFee = parseFloat(event.target.value);
                                    this.setState({ editedAccount: account });
                                }}
                                style={{ marginBottom: "16px" }}
                            />
                        </Col>
                    </Row>
                ) : null}
            </div>
        );
    }

    getAccountTypeList() {
        const { accountTypes } = this.context;

        let accountTypeSelectOptions  = [];
        accountTypes.map((type) => {
            return accountTypeSelectOptions.push({
                label: type.name,
                value: type,
            });
        });
        this.setState({accountTypes: accountTypeSelectOptions});
        return accountTypeSelectOptions;
    }

    routeContact(contact) {
        return (
            <Fa
                icon={"edit"}
                style={{ color: "#00afd7" }}
                onClick={() => {
                    this.props.history.push({
                        pathname: "/contact/" + contact.id,
                        state: { contact: contact },
                    });
                }}
            />
        );
    }

    renderContactTable() {
        if (this.state.contactsLoaded === true) {
            return (
                <DataTable striped info={false} small data={this.state.contacts}>
                    {" "}
                </DataTable>
            );
        } else {
            return <div></div>;
        }
    }

    formatCurrency(expense) {
        return new Intl.NumberFormat("en-US", {
            style: "currency",
            currency: "USD",
            minimumFractionDigits: 2,
        }).format(expense);
    }

    formatDateStringToISO(dateString) {
        if (dateString.includes("Z")) {
            return dateString;
        } else {
            return dateString.concat("Z");
        }
    }

    formatDateLong(date) {
        let dateString = this.formatDateStringToISO(date);
        let ndate = new Date(dateString);

        return new Intl.DateTimeFormat("en-US", {
            year: "numeric",
            month: "numeric",
            day: "2-digit",
            hour: "numeric",
            minute: "numeric"
        }).format(ndate);
    }

    renderLoadingSpinner() {
        return (
            <Container className="mt-5">
                <div style={{ textAlign: "center", verticalAlign: "center" }}>
                    <Spinner multicolor />
                </div>
            </Container>
        );
    }

    generateNote(note) {
        return (
            <MDBCard style={{ backgroundColor: "#FFF7D1" }}>
                <MDBCardHeader style={{ backgroundColor: "#FFF2AB" }}>
                    <MDBRow>
                        <MDBCol size="5">
                            {note.createdAt ? this.formatDateLong(note.createdAt): ""}
                        </MDBCol>

                        <MDBCol size="5">
                            {note.createdBy ? note.createdBy.firstname + " " + note.createdBy.lastname : ""}
                        </MDBCol>
                        <MDBCol onClick={() => this.toggleEditModalPopup(note)} size="2">
                            <MDBIcon
                                style={{ color: "#857E59", padding: 4, float: "right" }}
                                data-tip={"Edit"}
                                icon="ellipsis-v"
                            />
                        </MDBCol>
                    </MDBRow>
                </MDBCardHeader>

                <MDBCardBody>{note.text}</MDBCardBody>
            </MDBCard>
        );
    }

    renderNotesSection() {
        let notes = this.sortNotes(this.state.allNotes);

        return (
            <div>
                {notes.map((n, idx) => {
                    return (
                        <div key={idx} style={{ paddingBottom: 6 }}>
                            {this.generateNote(n)}
                        </div>
                    );
                })}
            </div>
        );
    }

    generateTask(note) {
        function renderAssignedTo() {
            if (note.assignedTo) {
                return (
                    <span style={{ fontSize: 14 }}>
                        {note.createBy ? note.createdby.username : " "}
                        <MDBIcon
                            icon="long-arrow-alt-right"
                            data-tip={"Assigned To"}
                        />{" "}
                        {note.assignedTo.username}
                    </span>
                );
            }
        }

        return (
            <MDBCard style={{ backgroundColor: "#FFE4F1" }}>
                <MDBCardHeader style={{ backgroundColor: "#FFCCE5" }}>
                    <MDBRow>
                        <MDBCol size="5" style={{ fontSize: 14 }}>
                            {note.createdAt ? this.formatDateLong(note.createdAt) : ""}
                        </MDBCol>

                        <MDBCol size="5" style={{ fontSize: 14 }}>
                            {note.createdBy ? note.createdBy.firstname + " " + note.createdBy.lastname : ""}
                            {renderAssignedTo()}
                        </MDBCol>

                        <MDBCol siz="2">
                            <MDBIcon
                                onClick={() => this.toggleEditModalPopup(note)}
                                style={{
                                    color: "#7B626E",
                                    float: "right",
                                    padding: "4px 4px 4px 8px",
                                }}
                                data-tip={"Edit"}
                                icon="ellipsis-v"
                            />
                            <MDBIcon
                                style={{
                                    color: "#7B626E",
                                    float: "right",
                                    padding: "4px 8px 4px 4px",
                                }}
                                onClick={() => this.updateNote(note, true)}
                                data-tip={"Complete"}
                                icon="check"
                            />
                        </MDBCol>
                    </MDBRow>
                </MDBCardHeader>

                <MDBCardBody>{note.text}</MDBCardBody>
                <ReactTooltip />
            </MDBCard>
        );
    }

    renderTasksSection() {
        let tasks = this.sortNotes(this.state.allNotes, true);

        return (
            <div>
                {tasks.map((n, idx) => {
                    return (
                        <div key={idx} style={{ paddingBottom: 6 }}>
                            {this.generateTask(n)}
                        </div>
                    );
                })}
            </div>
        );
    }

    renderNotesList() {
        return (
            <div>
                <MDBRow>
                    <MDBCol className={"pvNotesGroupOuterContainer"} size="6">
                        <div className={"pvNotesGroupInnerContainer"}>
                            {this.renderNotesSection()}
                        </div>
                    </MDBCol>

                    <MDBCol className={"pvNotesGroupOuterContainer"} size="6">
                        <div className={"pvNotesGroupInnerContainer"}>
                            {this.renderTasksSection()}
                        </div>
                    </MDBCol>
                </MDBRow>
            </div>
        );
    }

    renderAddContactModal() {
        return (
            <div>
                <Container>
                    <Row>
                        <Modal
                            centered
                            className="form-elegant"
                            isOpen={this.state.contactModalOpen}
                            toggle={() => this.toggleContactModalPopup()}
                        >
                            <ModalBody
                                style={{ backgroundColor: "#FFFFFF" }}
                                className="mx-3"
                            >
                                <CardHeader
                                    color={"indigo"}
                                    className=" text-center"
                                >
									Add New Contact
                                </CardHeader>

                                <CardBody>
                                    <Row style={{ display: "flex", justifyContent: "center", gap:"3px", marginBottom: "5px" }}>
                                        <Col size="3.5">
                                            <Input
                                                label="First Name"
                                                value={this.state.newContact.firstname}
                                                onChange={this.contactChange.bind(this, "firstname")}
                                            />
                                        </Col>

                                        <Col size="3.5">
                                            <Input
                                                label="Last Name"
                                                value={this.state.newContact.lastname}
                                                onChange={this.contactChange.bind(this, "lastname")}
                                            />
                                        </Col>

                                        <Col size="3.5">
                                            <Input
                                                label="Phone"
                                                value={this.state.newContact.phone}
                                                onChange={this.contactChange.bind(this, "phone")}
                                            />
                                        </Col>
                                    </Row>

                                    <Row style={{ display: "flex", justifyContent: "center", gap:"3px", marginBottom: "5px" }}>
                                        <Col size="5">
                                            <Input
                                                label="Email"
                                                value={this.state.newContact.email}
                                                onChange={this.contactChange.bind(this, "email")}
                                            />
                                        </Col>

                                        <Col size="5">
                                            <Input
                                                label="Title"
                                                value={this.state.newContact.role}
                                                onChange={this.contactChange.bind(this, "role")}
                                            />
                                        </Col>
                                    </Row>

                                    <Row style={{ display: "flex", justifyContent: "center" }}>
                                        <Col size="8">
                                            <Select
                                                placeholder={"Select Contact Type..."}
                                                options={this.state.contactTypes}
                                                onChange={this.handleContactTypeSelected.bind(this)}
                                            />
                                        </Col>
                                    </Row>

                                    <Col size="12">
                                        <hr />
                                    </Col>

                                    <Row>
                                        <Col size="5">
                                            <Input
                                                onClick={() => this.setState({ typeRadio: "Note" })}
                                                checked={this.state.typeRadio === "Note"}
                                                label="Note"
                                                type="radio"
                                                id="noteRadio"
                                            />
                                        </Col>
                                        <Col size="5">
                                            <Input
                                                onClick={() => this.setState({ typeRadio: "Task" })}
                                                checked={this.state.typeRadio === "Task"}
                                                label="Task"
                                                type="radio"
                                                id="taskRadio"
                                            />
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col md="12">
                                            <textarea
                                                placeholder={"Enter Text"}
                                                id={"newNoteText"}
                                                style={{ width: "100%", height: "160px" }}
                                            ></textarea>
                                        </Col>
                                    </Row>
                                </CardBody>
                                <Button onClick={this.addNewContact.bind(this)}>
                                    {" "}
									Add Contact{" "}
                                </Button>
                            </ModalBody>
                        </Modal>
                    </Row>
                </Container>
            </div>
        );
    }

    renderNoteModal() {
        return (
            <MDBContainer>
                <MDBRow>
                    <MDBModal
                        centered
                        isOpen={this.state.noteModalOpen}
                        toggle={() => this.setState({ noteModalOpen: false })}
                        maxWidth="sm" 
                        fullWidth={true}
                    >
                        <MDBModalBody>
                            <MDBCardHeader className=" text-center" style={{ backgroundColor: "primary" }}>
								Add New Note
                            </MDBCardHeader>
                            <form className=" mx-3 grey-text">
                                <textarea
                                    placeholder={"Add note text here."}
                                    autoFocus
                                    id={"newActivityNoteText"}
                                    style={{ width: "100%", height: "200px", marginBottom: "10px" }}
                                ></textarea>

                                <Row>
                                    <Col size="12">
                                        <div className={"datePickerOptions"}>
                                            <DatePicker
                                                format="MM-DD-YYYY"
                                                hint={"01-01-1900"}
                                                keyboard
                                                getValue={(evt) => {
                                                    console.log(evt);
                                                    this.setState({ dueDate: evt });
                                                }}
                                                mask={[
                                                    /\d/,
                                                    /\d/,
                                                    "-",
                                                    /\d/,
                                                    /\d/,
                                                    "-",
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                    /\d/,
                                                ]}
                                                label="Due Date"
                                            />
                                        </div>
                                    </Col>
                                </Row>

                                <Row>
                                    <Col size="6">
                                        <Input
                                            type="radio"
                                            gap
                                            label={"Note"}
                                            checked={this.state.taskCompleted}
                                            onClick={() => this.setState({ taskCompleted: true })}
                                            id={"noteRadio"}
                                        />
                                    </Col>

                                    <Col size="6">
                                        <Input
                                            type="radio"
                                            gap
                                            label={"Task"}
                                            checked={!this.state.taskCompleted}
                                            onClick={() => this.setState({ taskCompleted: false })}
                                            id={"taskRadio"}
                                        />
                                    </Col>
                                </Row>
                                <br />

                                <ModalFooter>
                                    <span
                                        className={"ptBtn saveBtn"}
                                        data-tip={"Add Note"}
                                        onClick={this.addNewNote.bind(this)}
                                    >
                                        <Fa size="2x" icon={"check"}>
                                            {" "}
                                        </Fa>
                                    </span>
                                    <span
                                        className={"ptBtn cancelBtn"}
                                        data-tip={"Cancel"}
                                        onClick={() => this.setState({ noteModalOpen: false })}
                                    >
                                        <Fa size="2x" icon={"times"}>
                                            {" "}
                                        </Fa>
                                    </span>
                                </ModalFooter>
                                <ReactTooltip />
                            </form>
                        </MDBModalBody>
                    </MDBModal>
                </MDBRow>
            </MDBContainer>
        );
    }

    renderAddCallModal() {
        return (
            <MDBModal
                size="lg"
                centered
                isOpen={this.state.callModalOpen}
                toggle={() => this.setState({ callModalOpen: false })}
                maxWidth={"sm"}
                fullWidth={true}
            >
                <MDBModalHeader style={{ color: 'white', backgroundColor: '#5881c1' }}>
					Add New Call
                </MDBModalHeader>
                <MDBModalBody style={{ paddingTop: "16px" }}>
                    <div>
                        <MDBRow style={{ marginBottom: "16px" }}>
                            <MDBCol md="6">
                                <Input
                                    onChange={(evt) => {
                                        let newCall = this.state.newCall;
                                        newCall.quality = evt.target.checked;
                                        newCall.callType = null;
                                        newCall.callReason = null;
                                        this.setState({ newCall: newCall });
                                    }}
                                    filled
                                    label="Marketing"
                                    type="checkbox"
                                    id="checkbox6"
                                    checked={this.state.newCall.quality}
                                />
                            </MDBCol>
                            <MDBCol md="6">
                                <DatePicker
                                    format="MM-DD-YYYY"
                                    hint={"01-01-1900"}
                                    keyboard
                                    getValue={(event) => {
                                        let call = this.state.newCall;
                                        call.when = event;
                                        this.setState({ newCall: call });
                                    }}
                                    mask={[/\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
                                    label="Call Date"
                                    className="openDatePicker"
                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md="12">
                                <Select
                                    placeholder={"Select Contact..."}
                                    options={this.state.contactList}
                                    onChange={e => {
                                        let call = this.state.newCall,
                                            contact = { id: e.value.id, firstname: e.value.firstname, lastname: e.value.lastname, role: e.value.role };

                                        call.contacts.push(contact);

                                        this.setState({
                                            newCall: call,
                                        });
                                    }}
                                />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md="12">
                                <br />
                            </MDBCol>
                        </MDBRow>
                        <MDBRow>
                            <MDBCol md="12">
                                {this.state.newCall.quality === false ?
                                    <Select
                                        placeholder={"Select Call Type..."}
                                        options={this.state.callTypes}
                                        onChange={(e) => {
                                            let call = this.state.newCall;

                                            call.callType = e.value;

                                            this.setState({
                                                newCall: call,
                                            });
                                        }}
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}

                                    />
                                    :
                                    <Select
                                        placeholder={"Select Call Reason..."}
                                        options={this.state.callReasons}
                                        onChange={(e) => {
                                            let call = this.state.newCall;

                                            call.callReason = e.value;

                                            this.setState({
                                                newCall: call,
                                                isOtherReason: e.value === "Other" ? "flex" : "none"
                                            });
                                        }}
                                        menuPortalTarget={document.body}
                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                    />
                                }
                            </MDBCol>
                            <MDBCol md="12">
                                <br />
                            </MDBCol>
                        </MDBRow>
                    </div>
                </MDBModalBody>
                <MDBModalFooter>
                    <MDBRow>
                        <MDBCol md="4">
                            <div style={{ paddingTop: 25 }}>
                                <MDBBtn
                                    size="sm"
                                    color={"success"}
                                    onClick={() => this.createActivity("Call")}
                                >
									Save
                                </MDBBtn>
                            </div>
                        </MDBCol>
                    </MDBRow>
                </MDBModalFooter>
            </MDBModal>
        );
    }

    renderAddAppointmentModal() {
        return (
            <MDBModal
                centered
                isOpen={this.state.appointmentModalOpen}
                toggle={() => this.setState({ appointmentModalOpen: false })}
                
            >
                <MDBModalHeader style={{ color: 'white', backgroundColor: '#5881c1' }}>
                    Add New Appointment
                </MDBModalHeader>

                <MDBRow style={{ marginTop: "16px", marginBottom: "16px", paddingLeft: "5px", paddingRight: "5px" }}>
                    <MDBCol size="6" >
                        <DatePicker
                            format="MM-DD-YYYY"
                            hint={"01-01-1900"}
                            keyboard
                            getValue={(event) => {
                                let activity = this.state.newActivity;
                                activity.when = event;
                                this.setState({ newActivity: activity });
                            }}
                            mask={[/\d/, /\d/, "-", /\d/, /\d/, "-", /\d/, /\d/, /\d/, /\d/]}
                            label="Appointment Date"
                        />
                        </MDBCol>
                        <MDBCol size="6">
                            <MDBInput
                                label="Amount Spent"
                                outline
                                value={this.state.newActivity.expenses}
                                onChange={(evt) => {
                                    let activity = this.state.newActivity;
                                    activity.expenses = evt.target.value;
                                    this.setState({ newActivity: activity });
                                }}
                            />
                        </MDBCol>
                    </MDBRow>

                    <MDBRow style={{ marginTop: "16px", marginBottom: "16px", paddingLeft: "5px", paddingRight: "5px", gap:"10px" }}>
                        <Col size="5">
                            <Select
                                placeholder={"Select Card Type"}
                                options={this.state.cardTypes}
                                onChange={this.handleCardTypeSelected.bind(this)}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Col>

                        <Col size="5">
                            <Select
                                placeholder={"Select Expense Type"}
                                options={this.state.expenseTypes}
                                onChange={this.handleExpenseTypeSelected.bind(this)}
                                menuPortalTarget={document.body}
                                styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                            />
                        </Col>
                    </MDBRow>

                    <MDBRow style={{ marginBottom: "16px", paddingLeft: "5px" }}>
                        <Col size="5">
                            <Input
                                label="Appointment Description"
                                outline
                                containerClass={"medMargin"}
                                value={this.state.newActivity.expenseDesc}
                                onChange={(evt) => {
                                    let activity = this.state.newActivity;
                                    activity.expenseDesc = evt.target.value;
                                    this.setState({ newActivity: activity });
                                }}
                                style={{ width: "100%" }}
                            />
                        </Col>
                    </MDBRow>

                    <MDBRow style={{ marginBottom: "10px", paddingLeft: "5px", gap:"3px" }}>
                        <Col size="5">
                            <Input
                                label="Vendor"
                                outline
                                containerClass={"medMargin"}
                                value={this.state.newActivity.vendor}
                                onChange={(evt) => {
                                    let activity = this.state.newActivity;
                                    activity.vendor = evt.target.value;
                                    this.setState({ newActivity: activity });
                                }}
                                style={{ width: "100%" }}
                            />
                        </Col>

                        <Col size="5">
                            <Input
                                type="number"
                                label="People Attending (amount)"
                                outline
                                containerClass={"medMargin"}
                                value={this.state.newActivity.peopleAttending}
                                onChange={(evt) => {
                                    let activity = this.state.newActivity;
                                    activity.peopleAttending = parseInt(evt.target.value);
                                    this.setState({ newActivity: activity });
                                }}
                                style={{ width: "100%" }}
                            />
                        </Col>
                    </MDBRow>

                    <MDBRow style={{ marginBottom: "10px", paddingLeft: "5px", gap:"3px" }}>
                        <Col size="5">
                            <Input
                                label="Topics Discussed"
                                outline
                                containerClass={"medMargin"}
                                value={this.state.newActivity.educationalTopics}
                                onChange={(evt) => {
                                    let activity = this.state.newActivity;
                                    activity.educationalTopics = evt.target.value;
                                    this.setState({ newActivity: activity });
                                }}
                                style={{ width: "100%" }}
                            />
                        </Col>

                        <Col size="5">
                            <Input
                                label="Physicians Attending (names)"
                                outline
                                containerClass={"medMargin"}
                                value={this.state.newActivity.physiciansAttending}
                                onChange={(evt) => {
                                    let activity = this.state.newActivity;
                                    activity.physiciansAttending = evt.target.value;
                                    this.setState({ newActivity: activity });
                                }}
                                style={{ width: "100%" }}
                            />
                        </Col>
                    </MDBRow>
                <Row>
                    <Col size="4">
                        <Input
                            disabled={true}
                            filled
                            checked={this.state.newActivity.accountWasTarget === true}
                            label="Target Account"
                            type="checkbox"
                            id="checkbox_account_was_target"
                        />
                    </Col>

                    <Col size="4">
                        <Input
                            onChange={(event) => {
                                let updatedActivity = this.state.newActivity;
                                updatedActivity.inOpenTerritory = event.target.checked;
                                this.setState({ newActivity: updatedActivity });
                            }}
                            filled
                            checked={this.state.newActivity.inOpenTerritory === true}
                            label="In Open Territory"
                            type="checkbox"
                            id="checkbox_in_open_territory"
                        />
                    </Col>

                    <Col size="4">
                        <Input
                            onChange={(event) => {
                                let updatedActivity = this.state.newActivity;
                                updatedActivity.salesManagerAttended = event.target.checked;
                                this.setState({ newActivity: updatedActivity });
                            }}
                            filled
                            checked={this.state.newActivity.salesManagerAttended === true}
                            label="Sales Manager Attended"
                            type="checkbox"
                            id="checkbox_sales_manager_attended"
                        />
                    </Col>
                </Row>

                    <MDBRow style={{ justifyContent: "space-evenly" }}>
                        {this.renderReceipt()}
                    </MDBRow>

                <MDBModalFooter>
                    <MDBRow>
                        <MDBCol md="4">
                            <div style={{ paddingTop: 25 }}>
                                <MDBBtn
                                    size="sm"
                                    color={"success"}
                                    onClick={() => this.createActivity("Appointment")}
                                >
                                    Save
                                </MDBBtn>
                            </div>
                        </MDBCol>
                    </MDBRow>
                </MDBModalFooter>
            </MDBModal>
        );
    }

    renderEditNoteModal() {
        let note = this.state.modalNote,
            isTask = note.completed === false;

        let bgClass = "orderNotesModal",
            bgColor = "#FFF7D1";

        if (isTask) {
            bgClass = "orderTasksModal";
            bgColor = "#FFE4F1";
        }
        return (
            <MDBModal
                className={bgClass}
                centered
                isOpen={this.state.editNoteOpen}
                toggle={() => this.toggleEditModalPopup()}
            >
                <MDBModalBody>
                    <MDBRow>
                        <MDBCol size="12">
                            <textarea
                                id={"noteTextArea"}
                                style={{
                                    width: "100%",
                                    height: "200px",
                                    backgroundColor: bgColor,
                                }}
                            >
                                {note.text}
                            </textarea>
                        </MDBCol>

                        <MDBCol size="12">
                            <span>Updated: {GlobalFunctions.formatDate(new Date())}</span>

                            <MDBIcon
                                style={{ color: "#7B626E", float: "right", padding: 4 }}
                                data-tip={"Update"}
                                icon="check"
                                onClick={() => {
                                    this.updateNoteModal(note);
                                    this.toggleEditModalPopup();
                                }}
                            />
                        </MDBCol>
                    </MDBRow>
                </MDBModalBody>
                <ReactTooltip />
            </MDBModal>
        );
    }

    renderPricesheetSection() {
        if (!this.state.pricesheetsLoaded) {
            return this.renderLoadingSpinner();
        }
        return (
            <Card style={{ backgroundColor: "rgb(88,129,193)" }}>
                <InlineTable
                    tableHeader="Account Pricesheets"
                    paging={true}
                    columnFieldMap={this.state.pricesheetColumnMap}
                    allowRowSearch={false}
                    batchSave={true}
                    inlineEdit={true}
                    rows={this.state.pricesheets}
                    addItemMethod={this.createNewPricesheet.bind(this)}
                    editRowsMethod={this.editPricesheetRows.bind(this)}
                    modalHeader="Add Pricesheet"
                />
            </Card>);
    }

    createNewPricesheet(sheet) {
        const { currentUser } = this.context;
        sheet.updatedById = currentUser.id;
        sheet.updatedOn = new Date().toISOString();
        sheet.accountId = parseInt(this.state.accountId);

        AccountService.CreateAccountPricesheet(sheet)
            .then(res => {
                this.setState({
                    pricesheetsLoaded: false,
                }, () => this.getPricesheets(this.state.accountId));
            })
            .catch(ex => {
                console.log(ex);
            });
    }

    editPricesheetRows(sheets) {
        const { currentUser } = this.context;

        sheets.forEach(sheet => {
            sheet.updatedById = currentUser.id;
            sheet.updatedOn = new Date().toISOString();
        });

        AccountService.UpdatePricesheets(sheets)
            .then(res => {
                this.setState({
                    pricesheetsLoaded: false,
                }, () => this.getPricesheets(this.state.accountId));
            })
            .catch(ex => {
                console.log(ex);
            });
    }

    renderContent() {
        const { companyName } = this.context;
        if (this.state.notesLoaded === false) {
            return this.renderLoadingSpinner();
        }

        let account = this.state.editedAccount;

        return (
            <MUIThemeProvider theme={fixedLightMaterialUITheme}>
            <div>
                <ToastContainer
                    hideProgressBar={false}
                    newestOnTop={true}
                    autoClose={3000}
                />

                <CardHeader
                    style={{
                        paddingTop: 12,
                        paddingBottom: 8,
                        marginBottom: 10,
                        color: "white",
                        fontSize: 18,
                        backgroundColor: "#5881c1",
                    }}
                >
                    <Row>
                        <Col size="5">
                            <span style={{ fontSize: 24 }}>{account.name}</span>
                        </Col>
                        <Col size="3">
                            <span style={{ fontSize: 24 }}>
                                {account.owner ? account.owner.firstname + " " + account.owner.lastname : "No Owner"}
                            </span>
                        </Col>

                        <Col size="2" style={{ display: "flex", gap: "16px" }}>
                            <MDBBtn
                                className="px-2 toolbarButton"
                                outline
                                rounded
                                size="sm"
                                color={"secondary"}
                                data-tip={"Add Note / Task"}
                                data-place={"bottom"}
                                onClick={() => {
                                    this.toggleNoteModalPopup();
                                }}
                            >
                                <MDBIcon icon="sticky-note" />
                            </MDBBtn>

                            <MDBBtn
                                className="px-2 toolbarButton"
                                outline
                                rounded
                                size="sm"
                                color={"amber"}
                                data-tip={"Add Call"}
                                data-place={"bottom"}
                                onClick={() => {
                                    let a = this.state.newActivity;
                                    a.type = "Call";
                                    this.setState({
                                        callModalOpen: true,
                                        newActivity: a,
                                    });
                                }}
                            >
                                <MDBIcon icon="phone" />
                            </MDBBtn>

                            <MDBBtn
                                className="px-2 toolbarButton"
                                outline
                                rounded
                                size="sm"
                                color={"yellow"}
                                data-tip={"Add Appointment"}
                                data-place={"bottom"}
                                onClick={() => {
                                    let newActivity = this.state.newActivity;
                                    newActivity.type = "Appointment";
                                    newActivity.accountWasTarget = this.state.account.isTarget === true;

                                    this.setState({
                                        appointmentModalOpen: true,
                                        newActivity: newActivity,
                                    });
                                }}
                            >
                                <MDBIcon icon="handshake" />
                            </MDBBtn>

                            <MDBBtn
                                className="px-2 toolbarButton"
                                outline
                                rounded
                                size="sm"
                                color={"orange"}
                                data-tip={"Add Contact"}
                                data-place={"bottom"}
                                onClick={() => {
                                    this.toggleContactModalPopup();
                                }}
                            >
                                <MDBIcon icon="user" />
                            </MDBBtn>

                            <MDBBtn
                                onClick={() => this.updateAccount()}
                                data-tip={"Save Account"}
                                data-place={"bottom"}
                                outline
                                rounded
                                size="sm"
                                color="success"
                                className="px-2 toolbarButton"
                            >
                                <MDBIcon icon="save" />
                            </MDBBtn>
                        </Col>
                    </Row>
                </CardHeader>
                {this.renderNoteModal()}
                {this.renderAddCallModal()}
                {this.renderAddAppointmentModal()}
                <Container className="mt-4">
                    <Row>
                        <Col md="12">
                            <MDBNav className="nav-justified navFull" color={"blue"}>
                                <MDBNavItem>
                                    <MDBNavLink
                                        link
                                        to="#"
                                        className={classnames({
                                            active: this.state.activeItem === "1",
                                        })}
                                        onClick={() => {
                                            this.toggle("1");
                                        }}
                                        role="tab"
                                    >
										Notes & Tasks
                                    </MDBNavLink>
                                </MDBNavItem>

                                <MDBNavItem>
                                    <MDBNavLink
                                        link
                                        to="#"
                                        className={classnames({
                                            active: this.state.activeItem === "2",
                                        })}
                                        onClick={() => {
                                            this.toggle("2");
                                        }}
                                        role="tab"
                                    >
										Activities
                                    </ MDBNavLink>
                                </MDBNavItem>

                                <MDBNavItem>
                                    <MDBNavLink
                                        link
                                        to="#"
                                        className={classnames({
                                            active: this.state.activeItem === "3",
                                        })}
                                        onClick={() => {
                                            this.toggle("3");
                                        }}
                                        role="tab"
                                    >
										Orders
                                    </MDBNavLink>
                                </MDBNavItem>

                                <MDBNavItem>
                                    <MDBNavLink
                                        link
                                        to="#"
                                        className={classnames({
                                            active: this.state.activeItem === "4",
                                        })}
                                        onClick={() => {
                                            this.toggle("4");
                                        }}
                                        role="tab"
                                    >
										Contacts
                                    </MDBNavLink>
                                </MDBNavItem>

                                <MDBNavItem>
                                    <MDBNavLink
                                        link
                                        to="#"
                                        className={classnames({
                                            active: this.state.activeItem === "5",
                                        })}
                                        onClick={() => {
                                            this.toggle("5");
                                        }}
                                        role="tab"
                                    >
										Details
                                    </MDBNavLink>
                                </MDBNavItem>

                                {companyName !== "rehabmedical" ?
                                    <MDBNavItem>
                                        <MDBNavLink
                                            link
                                            to="#"
                                            className={classnames({
                                                active: this.state.activeItem === "6",
                                            })}
                                            onClick={() => {
                                                this.toggle("6");
                                            }}
                                            role="tab"
                                        >
											Pricesheets
                                        </MDBNavLink>
                                    </MDBNavItem>
                                    : ""}
                            </MDBNav>

                            <MDBTabContent className="card" activeItem={this.state.activeItem}>
                                <MDBTabPane tabId="1" activeItem={this.state.activeItem} role="tabpanel">
                                    {this.renderNotesList()}
                                </MDBTabPane>
                                <MDBTabPane tabId="2" activeItem={this.state.activeItem} role="tabpanel">
                                    {this.renderActivityTable()}
                                </MDBTabPane>
                                <MDBTabPane tabId="3" activeItem={this.state.activeItem} role="tabpanel">
                                    {this.renderOrderTable()}
                                </MDBTabPane>
                                <MDBTabPane tabId="4" activeItem={this.state.activeItem} role="tabpanel">
                                    {this.renderContactTable()}
                                </MDBTabPane>
                                <MDBTabPane tabId="5" activeItem={this.state.activeItem} role="tabpanel">
                                    {this.renderInformationSection()}
                                </MDBTabPane>
                                {companyName !== "rehabmedical" ?
                                    <MDBTabPane tabId="6" activeItem={this.state.activeItem} role="tabpanel">
                                        {this.renderPricesheetSection()}
                                    </MDBTabPane>
                                    : ""}
                            </MDBTabContent>
                        </Col>
                    </Row>
                    {this.renderAddContactModal()}
                    {this.renderEditNoteModal()}
                </Container>
                <ReactTooltip />
            </div>
            </MUIThemeProvider>
        );
    }
}
